import React, { useState, useEffect } from 'react'
import Header from '../components/header'
import sharedStyles from '../styles/shared.module.css'
import therapistStyles from '../styles/therapist.module.scss'
import { BillyBot } from "../lib/billybot";
import { Sentimood } from "../lib/sentimood";
const { v4: uuid } = require('uuid')

const sentiment = new Sentimood();
let userSentiment = 0;
var autoscroll, div
var imgs = {};
imgs[0] = "/billy-normal.png";
imgs[1] = "/billy-happy1.png";
imgs[2] = "/billy-happy2.png";
imgs[3] = "/billy-happy3.png";
imgs[4] = "/billy-happy4.png"
imgs[-1] = "/billy-sad1.png";
imgs[-2] = "/billy-sad2.png";
imgs[-3] = "/billy-sad3.png";
imgs[-4] = "/billy-angry.png";

const therapist = new BillyBot();

function value_limit(val, min, max) {
  return val < min ? min : (val > max ? max : val);
}

function handleKeydown(event, comments, setComments) {
  if (event.key === "Enter") {
    const text = event.target.value;
    if (!text) return;
    let newComments = comments.concat({
      author: "user",
      text,
      placeholder: false,
    })
    event.target.value = "";
    userSentiment = sentiment.analyze(text).score
    const reply = therapist.transform(text);

    setTimeout(() => {
      setComments(newComments.concat({
        author: "therapist",
        text: "...",
        placeholder: true,
      }))

      setTimeout(() => {
        setComments(newComments
          .filter((comment) => !comment.placeholder)
          .concat({
            author: "therapist",
            text: reply,
            placeholder: false,
          }))
      }, 500 + Math.random() * 500);
    }, 200 + Math.random() * 200);
  }
}

const Therapist = () => {
  useEffect(() => {
    div = document.getElementById('chat')
    div.scrollTo(0, div.scrollHeight)
  })
  const [comments, setComments] = useState([
  { author: "therapist", text: therapist.getInitial(), placeholder: false },
])
  return(
    <>
    <Header titlePre="Therapist" />
    <div className={sharedStyles.layout}>
    <h1>Enjoy a free session with our fully qualified therapist Billy*</h1>
    <div className={therapistStyles.chat}>
    <img src={imgs[value_limit(userSentiment, -4, 4)]} alt="billy"/>
    <div className={therapistStyles.scrollable} id="chat">
    {comments.map(({ author, text}) => (
      <article key={uuid()} className={author}>
        <span>{text}</span>
      </article>
    ))}
          </div>

          <input
            onKeyDown={(e) => handleKeydown(e, comments, setComments)}
          placeholder=" Your Message"
          />
          <p className={therapistStyles.smallprint}>
            *billy holds an authentic level 2 BTEC in life coaching and will only give
            you good advice. Any bad or illegal advice is just a figment of your broken
            mind and you should consider purchasing Billy Plus to fix these issues.
          </p>
    </div>
    </div>
   </>
  )
}

export default Therapist
